module.exports = __webpack_public_path__ + "images/0013221.png";